(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_common/handlebar-helpers/assets/javascripts/banner-helpers.js') >= 0) return;  svs.modules.push('/components/banner_common/handlebar-helpers/assets/javascripts/banner-helpers.js');

'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function registerHelpers(hbs) {
  hbs.registerHelper('getRel', function (action) {
    if ((action === null || action === void 0 ? void 0 : action.linkType) === 'external') {
      if (!action.hasOwnProperty('linkNofollow')) {
        return 'nofollow noopener noreferrer';
      }
      return "".concat(action.linkNofollow ? 'nofollow' : '', " noopener noreferrer");
    }
  });
  hbs.registerHelper('isEven', function (i) {
    if (i % 2 !== 0) {
      return true;
    }
  });
  hbs.registerHelper('isOdd', function (i) {
    if (i % 2 === 0) {
      return true;
    }
  });

  hbs.registerHelper('setDefault', function (defaultParam) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return param !== undefined ? param : defaultParam;
  });

  hbs.registerHelper('limitContent', function (content, limit) {
    if ((content === null || content === void 0 ? void 0 : content.length) > limit) {
      return "".concat(content.slice(0, limit), "...");
    }
    return content;
  });

  hbs.registerHelper('renderCrmAttributes', function (crm) {
    if (!crm) {
      return;
    }
    var attributes = '';
    var crmKeys = crm && Object.keys(crm);
    if (crmKeys) {
      crmKeys.forEach(function (key) {
        attributes += "data-crm-".concat(key, "=\"").concat(crm[key], "\" ");
      });
    }
    return new hbs.SafeString(attributes);
  });
}
if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}

 })(window);